import axios from '@/plugins/axios'

export function getAdvertisement(params = {}) {
  return axios.get('advertisements', {
    params,
  })
}

export function getAdvertisementSelectData() {
  return axios.get('advertisements/advertisementSelectData')
}

export function editAdvertisement(id) {
  return axios.get(`advertisements/${id}/edit`)
}

export function storeAdvertisement(data) {
  return axios.post('advertisements', data)
}

export function updateAdvertisement(id, data) {
  return axios.put(`advertisements/${id}`, data)
}
